import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "test" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "push-10-t fs-18" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("em", { class: "text-muted fs-12 push-15-t dis-block" }, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "inline-block text-white" }, "Let's Talk", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "push-5-t" }, null, -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-italic" }, [
  /*#__PURE__*/_createTextVNode("1 or 3-year terms available "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("+ custom transaction fees")
], -1 /* HOISTED */)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "inline-block" }
const _hoisted_12 = {
  key: 0,
  class: "h5 text-light"
}
const _hoisted_13 = {
  key: 1,
  class: "h5 text-light"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "per month", -1 /* HOISTED */)
const _hoisted_16 = { class: "row push-20-t" }
const _hoisted_17 = { class: "col-xs-10 col-xs-offset-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/img/check-mark-white.svg",
  class: "push-10-r"
}, null, -1 /* HOISTED */)
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 2,
  class: "row push-20-t"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h2", {
  class: "text-white text-center pt-20 pb-0 fs-24",
  style: {}
}, "Transaction Fees", -1 /* HOISTED */)
const _hoisted_22 = { class: "col-xs-10 col-xs-offset-1 push-10-t" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionFees = _resolveComponent("TransactionFees")!

  return (_openBlock(), _createElementBlock("div", {
    class: "registration-card",
    style: _normalizeStyle({backgroundColor: _ctx.planData.primaryColor})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", {
        class: "font-weight-bold fs-45",
        textContent: _toDisplayString(_ctx.planData.name)
      }, null, 8 /* PROPS */, _hoisted_2),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.planData.description), 1 /* TEXT */),
      (_ctx.planHasCustomPricing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createTextVNode(),
            _hoisted_7,
            _hoisted_8,
            _hoisted_9
          ]))
        : (!_ctx.isSelfPay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("h1", _hoisted_11, "$" + _toDisplayString(_ctx.planData.cost), 1 /* TEXT */),
              (_ctx.planData.key == 'essential')
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "  per month"))
                : _createCommentVNode("v-if", true),
              (_ctx.planData.key == 'professional')
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                    _createTextVNode("  /user "),
                    _hoisted_14,
                    _hoisted_15
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planData.features, (feature, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "text-left push-10 font-weight-bold",
              key: idx
            }, [
              _hoisted_18,
              _createElementVNode("span", { innerHTML: feature }, null, 8 /* PROPS */, _hoisted_19)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      (_ctx.showTransactionFees)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_TransactionFees, {
                couponCode: 'test',
                currentUser: _ctx.currentUser,
                plan: _ctx.plan,
                coupon: _ctx.coupon
              }, null, 8 /* PROPS */, ["currentUser", "plan", "coupon"])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 4 /* STYLE */))
}